/**
 * Primary business contacts per client.
 *
 * Hand-selected platform users (users.userId) who are the client's primary
 * business contacts — not technicians (those are clientTechs). Intentionally
 * empty until leadership supplies the list. A proper contacts table is
 * tracked in #227.
 *
 * Shape: { [clientID]: userId[] }
 */
export const CLIENT_PRIMARY_CONTACTS: Readonly<Record<string, readonly number[]>> = {};
